export default "/img/BA.18b793ef602141c02350655425784267.png";